<template>
  <div class="contact-cta">
    <div class="contact-cta-text">
      <h3>{{ heading }}</h3>
      <p>{{ description }}</p>
    </div>
    <a :href="href" class="btn-outline-white">{{ buttonText }}</a>
  </div>
</template>

<script>
export default {
  name: "ContactCta",
  props: {
    heading: {
      type: String,
      default: "Questions about your shipping?",
    },
    description: {
      type: String,
      default: "Our team is here to help with any shipping or order inquiries.",
    },
    buttonText: {
      type: String,
      default: "Contact support",
    },
    href: {
      type: String,
      default: "mailto:support@hooliganseyewear.com",
    },
  },
};
</script>
